// PILGRIMAGE screen markup. The map + step nodes + intro are rendered by the
// controller (pilgrimage.ts) into #pilgBody; this is the screen frame + back nav.
import { icon } from '../ui/icons';

export const pilgrimageHTML = /* html */ `
<div id="screenPilgrimage" class="pilgrimage-screen hidden">
  <button class="btn secondary back" id="pilgBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="content-head">
    <div class="content-title" id="pilgTitle">${icon('compass')} Pilgrimage</div>
    <div class="content-sub" id="pilgSub"></div>
  </div>
  <div id="pilgBody" class="pilg-body"></div>
  <!-- Step requirement / detail popover (tap-to-dismiss) -->
  <div id="pilgNodeInfo" class="pilg-node-info hidden" role="dialog" aria-hidden="true">
    <div class="pni-card">
      <div class="pni-ic" id="pniIc">${icon('compass', 28)}</div>
      <div class="pni-title" id="pniTitle"></div>
      <div class="pni-req" id="pniReq"></div>
      <div class="pni-prog" id="pniProg"></div>
      <button class="btn secondary" id="pniClose" type="button">Close</button>
    </div>
  </div>
  <!-- First-open intro PANEL (scrolls; the ← Home back stays above it so it can
       never trap). Theo's voice + three warm blocks + Begin / Not now. -->
  <div id="pilgIntro" class="pilg-intro hidden" aria-hidden="true">
    <div class="pilg-intro-card">
      <div id="pilgIntroMedia" class="pilg-intro-media"></div>
      <div class="pilg-intro-theo" id="pilgIntroTheo"></div>
      <div class="pilg-intro-block">
        <div class="pib-h">${icon('sprout', 16)} Why we walk</div>
        <div class="pib-t">Faith grows step by step. A pilgrimage gives our learning a destination.</div>
      </div>
      <div class="pilg-intro-block">
        <div class="pib-h">${icon('compass', 16)} How it works</div>
        <div class="pib-t">Each step asks something small: questions answered, a feast visited, the chapel restored. Finish a step and the next lights up.</div>
      </div>
      <div class="pilg-intro-block">
        <div class="pib-h">${icon('church', 16)} What it means</div>
        <div class="pib-t">Reach the monastery and you'll have walked the foundations of the faith, and earned the Apostles along the way.</div>
      </div>
      <div class="pilg-intro-actions">
        <button class="btn" id="pilgIntroBegin" type="button">Begin the Pilgrimage</button>
        <button class="btn secondary" id="pilgIntroNotNow" type="button">Not now</button>
      </div>
    </div>
  </div>
</div>`;
